__turbopack_context__.v({
  "answer": "ParagraphFaq-module__VD5RnG__answer",
  "details": "ParagraphFaq-module__VD5RnG__details",
  "eyebrow": "ParagraphFaq-module__VD5RnG__eyebrow",
  "header": "ParagraphFaq-module__VD5RnG__header",
  "heading": "ParagraphFaq-module__VD5RnG__heading",
  "list": "ParagraphFaq-module__VD5RnG__list",
  "question": "ParagraphFaq-module__VD5RnG__question",
  "root": "ParagraphFaq-module__VD5RnG__root",
  "row": "ParagraphFaq-module__VD5RnG__row",
});
